import { http } from "../../shared/api/http";

export type InventoryItem = {
  id: string;
  sku: string;
  name: string;
  vehicleApplication: string | null;
  description: string | null;
  unitCost: string;
  unitPrice: string;
  onHand: number;
};

export type PurchaseReceipt = {
  id: string;
  partId: string;
  partName: string;
  partNumber: string;
  vehicleApplication: string | null;
  quantity: number;
  supplier: string | null;
  notes: string | null;
  reference: string | null;
  unitCost: string;
  totalCost: string;
  receivedAt: string;
};

export type OperationsSummary = {
  openRepairOrders: number;
  repairOrdersByStatus: Array<{ status: string; count: number }>;
  invoices: { count: number; total: string; outstanding: string };
  payments: { count: number; collected: string };
};

export type FinancialReportPeriod = "day" | "month" | "year";
export type FinancialSummary = {
  period: {
    type: FinancialReportPeriod;
    anchor: string;
    timezone: string;
    start: string;
    endExclusive: string;
    startDate: string;
    endDateExclusive: string;
  };
  activity: { invoiceCount: number; paymentCount: number };
  financials: {
    revenue: string;
    collected: string;
    outstanding: string;
    partsRevenue: string;
    laborRevenue: string;
    otherRevenue: string;
    partsCost: string;
    grossProfit: string;
    grossMarginPercent: string;
    estimatedNetProfit: string;
    salesTax: string;
  };
  costCoverage: {
    unmappedPartCostLines: number;
    laborCostTracked: boolean;
    overheadTracked: boolean;
    estimateNotice: string;
  };
};

export const operationsApi = {
  inventory: async (search = "") => (await http.get<InventoryItem[]>("/v1/inventory/items",{params:search ? {search} : undefined})).data,
  purchaseItems: async () => (await http.get<InventoryItem[]>("/v1/purchase/items")).data,
  purchaseReceipts: async () => (await http.get<PurchaseReceipt[]>("/v1/purchase/receipts")).data,
  receivePurchase: async (payload: { partName: string; partNumber: string; vehicleApplication: string; quantity: number; reference?: string; supplier?: string; notes?: string }) =>
    (await http.post("/v1/purchase/receipts", payload)).data,
  reports: async () => (await http.get<OperationsSummary>("/v1/reports/operations-summary")).data,
  financialReport: async (period: FinancialReportPeriod,anchor: string) =>
    (await http.get<FinancialSummary>("/v1/reports/financial-summary",{params:{period,anchor}})).data
};
